import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo-lila.png'


const _hoisted_1 = { class: "call-top-bar" }
const _hoisted_2 = { class: "top-bar-right" }
const _hoisted_3 = { class: "call-duration" }

import { computed } from "vue";

interface Props {
  connected?: boolean;
  startedAt?: number;
  currentTime?: number;
  professionalName?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CallTopBar',
  props: {
    connected: { type: Boolean, default: false },
    startedAt: { default: 0 },
    currentTime: { default: 0 },
    professionalName: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const formattedDuration = computed(() => {
  if (!props.startedAt || !props.currentTime) return "00:00";

  const elapsed = Math.floor((props.currentTime - props.startedAt) / 1000);
  const minutes = Math.floor(elapsed / 60);
  const seconds = elapsed % 60;

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "top-bar-left" }, [
      _createElementVNode("div", { class: "logo-container" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Lila",
          class: "logo"
        }),
        _createElementVNode("span", { class: "call-title" }, "Consulta Online")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(["status-indicator", { connected: _ctx.connected }])
      }, null, 2),
      _createElementVNode("span", _hoisted_3, _toDisplayString(formattedDuration.value), 1)
    ])
  ]))
}
}

})